module.exports = __webpack_public_path__ + "img/wz_logo.4691389f.png";